import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'baf-dialogs',
  templateUrl: './dialogs.component.html',
  styleUrls: ['./dialogs.component.css']
})
export class DialogsComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/dialogs/dialogs.component.ts